import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import TowerContent from 'Components/Shared/Filters/TowerContent'
import {
  getProjectType,
  getActivityListByType,
  getTowerList,
} from 'features/filter/api'
import {
  GetProjectTypeReq,
  GetActivityReq,
  GetTowerListReq,
} from 'features/filter/types'
import {
  selectProjectType,
  selectActivityList,
  selectTowerList,
} from 'features/filter/selector'
import { Col, Row } from 'antd'
import {
  projectsByIdSelector,
  selectedProjectCodeSelector,
} from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
import { DropdownList, DropdownPopupMenu } from 'Components/Shared/Form'
import { fetchProjects } from 'features/project/project.api'
import { selectFilter } from 'features/adminReport/commissioning/selector'
import { Filter } from 'features/adminReport/commissioning/types'
import {
  updateFilter,
  clearFilter,
} from 'features/adminReport/commissioning/actions'
import {
  ProjectsFilter,
  ProjectTypeFilter,
  DateFilter,
  ButtonFilter,
  ActivityFilter,
} from './Components'
import MulticheckProject from 'Components/Shared/Filters/MulticheckProject'

type Props = {
  onSearch: (isClearFilter?: boolean) => void
  withPadding?: boolean
  onExport?: () => void
  exportData?: any[]
  isDownLoading?: boolean
} & ReduxProps &
  DispatchProps

const CommissioningFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    filter,
    projectsById,
    onSearch = () => {},
    withPadding = false,
    projectType,
    activityList,
    onExport,
    exportData,
    isDownLoading,
    towerList,
  } = props

  useEffect(() => {
    dispatch(clearFilter())
    onGetProjectType()
    dispatch(fetchProjects({ email: UserEmail, token }))
    return () => {
      dispatch(clearFilter())
    }
  }, [ProjectCode, UserEmail])

  useEffect(() => {
    if (filter.ProjectCode && filter.CommissionTypeList.length > 0) {
      onGetTowerList()
    }
  }, [filter.ProjectCode, filter.CommissionTypeList])

  const onGetProjectType = () => {
    const req: GetProjectTypeReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(getProjectType(token, req))
  }

  const onGetTowerList = () => {
    if (filter.ProjectCode.length === 1) {
      const constructTyp =
        filter.CommissionTypeList[0] === 2
          ? 'Commissioning'
          : filter.CommissionTypeList[0] === 3
          ? 'Safety'
          : 'Q1'
      const req: GetTowerListReq = {
        ProjectCode: filter.ProjectCode[0],
        UserEmail,
        ConstructionType: constructTyp,
      }
      dispatch(getTowerList(token, req))
    }
  }

  const onGetActivity = () => {
    if (filter.ProjectCode.length === 1) {
      const constructTyp =
        filter.CommissionTypeList[0] === 2
          ? 'Commissioning'
          : filter.CommissionTypeList[0] === 3
          ? 'Safety'
          : 'Q1'

      const req: GetActivityReq = {
        UserEmail,
        ProjectCode: filter.ProjectCode[0],
        ConstructionType: constructTyp,
        TowerList: filter.TowerList,
      }
      dispatch(getActivityListByType(token, req))
    }
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  const onClearSearch = () => {
    dispatch(clearFilter())
    onSearch(true)
  }

  const commissioningTyes = [
    {
      name: 'Q1',
      value: 1,
    },
    {
      name: 'Commissioning',
      value: 2,
    },
    {
      name: 'Safety',
      value: 3,
    },
  ]

  const isFilter = () => {
    return (
      filter.ActivityList.length > 0 ||
      filter.CommissionTypeList.length > 0 ||
      filter.Date.Mode !== '' ||
      filter.ProjectCode.length > 0 ||
      filter.ProjectTypeID !== 0 ||
      filter.TowerList.length > 0
    )
  }

  const selectedProject =
    filter.ProjectCode.length > 0
      ? `เลือก ${filter.ProjectCode.length} โครงการ`
      : ''

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <Row type="flex" justify="start">
        <Col span={8}>
          <ProjectTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectType={projectType}
          />
        </Col>
        {/* <Col span={8}>
          <ProjectsFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectsById={projectsById}
          />
        </Col> */}
        <Col span={8}>
          <Box>
            <DropdownPopupMenu
              label={'โครงการ'}
              placeholder="เลือกโครงการ"
              value={filter.ProjectCode.join(',')}
              disabled={false}
              content={
                <MulticheckProject
                  projectList={projectsById}
                  projectTypeID={filter.ProjectTypeID}
                  filter={filter.ProjectCode}
                  onChange={data => {
                    filter.ActivityList = []
                    filter.CommissionTypeList = []
                    filter.TowerList = []
                    filter.ProjectCode = data
                    onFilterChange(filter)
                  }}
                />
              }
              isActive={filter.ProjectCode.length > 0}
            />
          </Box>
        </Col>
        <Col span={8}>
          <Box>
            <DropdownList
              placeholder="เลือกหมวดงาน"
              label="หมวดงาน"
              value={filter.CommissionTypeList[0]}
              menu={commissioningTyes}
              onChange={(val: any) => {
                filter.TowerList = []
                filter.ActivityList = []
                filter.CommissionTypeList = [val]
                onFilterChange(filter)
              }}
            />
          </Box>
        </Col>

        <Col span={8}>
          <Box>
            <DropdownPopupMenu
              label={'อาคาร'}
              placeholder="ทั้งหมด"
              value={filter.TowerList.join(',')}
              disabled={
                filter.CommissionTypeList.length !== 1 ||
                filter.ProjectCode.length !== 1
              }
              content={
                <TowerContent
                  towers={towerList.List}
                  filter={filter.TowerList}
                  onChange={data => {
                    filter.ActivityList = []
                    filter.TowerList = data
                    onFilterChange(filter)
                    onGetActivity()
                  }}
                />
              }
              isActive={filter.TowerList.length > 0}
            />
          </Box>
        </Col>

        <Col span={8}>
          <ActivityFilter
            filter={filter}
            onFilterChange={onFilterChange}
            activityList={activityList.List}
          />
        </Col>
        <Col span={8}>
          <DateFilter filter={filter} onFilterChange={onFilterChange} />
        </Col>
        <Col span={16}></Col>
        <Col span={8}>
          <ButtonFilter
            onClearSearch={onClearSearch}
            onSearch={onSearch}
            isFilter={isFilter()}
            onExport={onExport}
            isDownLoading={isDownLoading}
            exportData={exportData}
            fileName="รายงานตรวจส่วนกลาง-Commissioning & Safety"
          />
        </Col>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  margin-bottom: 24px;
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const Box = styled.div`
  padding: 0 12px 12px 0;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    projectType: selectProjectType(state),
    projectsById: projectsByIdSelector(state),
    activityList: selectActivityList(state),
    towerList: selectTowerList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CommissioningFilter)
